import React, { useState, useEffect, useContext } from "react";
import "../common/custom_css.css";
import AuthContext from "../common/AuthContext";
import { API } from "../common/api-service";
import { Link, useHistory } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import CheckIcon from "@mui/icons-material/Check";
import ReplyIcon from "@mui/icons-material/Reply";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

export default function Comments() {
  const history = useHistory();
  const { authState } = useContext(AuthContext);
  const token = authState.token.slice(1, -1);

  const deleteRow = (id) => {
    if (window.confirm("Are you sure you wish to delete this item?"))
      API.updateItem("active_comments", id, { active: false }, token)
        .then((resp) => {
          API.getItems("comments/", token)
            .then((resp2) => {
              const rows = createRowsList(resp2, columns);
              setState({
                ...state,
                columns: columns,
                rows: rows,
              });
            })
            .catch((error) => console.log(error));
          history.push("/comments/");
        })
        .catch((error) => console.log(error));
  };

  const activeComment = (id) => {
    if (window.confirm("Are you sure you wish to active this item?"))
      API.updateItem("active_comments", id, { active: true }, token)
        .then((resp) => {
          API.getItems("comments/", token)
            .then((resp2) => {
              const rows = createRowsList(resp2, columns);
              setState({
                ...state,
                columns: columns,
                rows: rows,
              });
            })
            .catch((error) => console.log(error));
          history.push("/comments/");
        })
        .catch((error) => console.log(error));
  };

  const replyComment = (id) => {
    if (window.confirm("Are you sure you wish to active this item?"))
      API.updateItem("comments", id, { active: true }, token)
        .then((resp) => {
          API.getItems("comments/", token)
            .then((resp2) => {
              const rows = createRowsList(resp2, columns);
              setState({
                ...state,
                columns: columns,
                rows: rows,
              });
            })
            .catch((error) => console.log(error));
          history.push("/comments/");
        })
        .catch((error) => console.log(error));
  };

  const columns = React.useMemo(
    () => [
      {
        field: "actions",
        type: "actions",
        headerName: "Actions",
        width: 200,
        cellClassName: "actions",
        getActions: (params) => {
          return [
            <GridActionsCellItem
              icon={<ReplyIcon />}
              label="Edit"
              className="textPrimary"
              component={Link}
              to={{
                pathname: `/comments/reply/`,
                state: { id: params.id, article: params.article },
              }}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<CheckIcon />}
              label="Active"
              onClick={() => activeComment(params.id)}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<ArticleIcon />}
              label="Edit"
              className="textPrimary"
              component={Link}
              to={{
                pathname: `/comments/detail/`,
                state: { id: params.id },
              }}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={() => deleteRow(params.id)}
              color="inherit"
            />,
          ];
        },
      },
      { field: "id", headerName: "ID", width: 100 },
      { field: "body", headerName: "Body", width: 300 },
      { field: "name", headerName: "Name", width: 150 },
      { field: "email", headerName: "Email", width: 250 },
      { field: "active", headerName: "Is active?", width: 150 },
      { field: "parent", headerName: "Parent", width: 150 },
      { field: "article", headerName: "Article", width: 150 },
    ],
    [deleteRow, activeComment]
  );

  const initialState = {
    columns: [],
    rows: [],
  };
  const [state, setState] = useState(initialState);

  function createRowsList(rows, cols) {
    let validrows = [];
    rows &&
      rows.forEach((row) => {
        let validrow = {};
        cols &&
          cols.forEach((col) => {
            switch (col.field) {
              case "active":
                if (row[col.field]) {
                  validrow[col.field] = "✔";
                } else {
                  validrow[col.field] = "×";
                }
                break;
              default:
                validrow[col.field] = row[col.field];
                validrow["id"] = row["id"];
            }
          });
        validrows.push(validrow);
      });
    return validrows;
  }

  useEffect(() => {
    API.getItems("comments", token)
      .then((resp) => {
        const rows = createRowsList(resp, columns);
        setState({
          ...state,
          columns: columns,
          rows: rows,
        });
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <React.Fragment>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Comments</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Comments</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="card card-default">
            {/* <div className="col-sm-6" style={selectStore}>
          <StoreSelection />
        </div> */}
            <div className="card-body">
              <span>
                {"Total row: "}
                {state.rows.length}
              </span>
              <span>{/* {selectedIndexes.length} {rowText} selected */}</span>
              <div className="relativeWrapper">
                <div className="absoluteWrapper"></div>
                <DataGrid
                  rows={state.rows}
                  columns={columns}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 15 } },
                  }}
                  pageSizeOptions={[15, 25, 50, 100]}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
}
